import { apiFetch } from './apiService';

export async function apiGetUtilisateur() {
	const response = await apiFetch('/api/utilisateur');
	if (response.ok) {
		return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierUtilisateur(utilisateur) {
    const config = {
		method: 'PUT',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(utilisateur)
	};
	const response = await apiFetch('/api/utilisateur', config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiAjouterTypeObjet(modele, typeObjet) {
    const config = {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(typeObjet)
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/types-objet/ajouter`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierInfosTypeObjet(modele, typeObjet) {
    const config = {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(typeObjet)
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/types-objet/${typeObjet.id}/modifier-infos`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiSupprimerTypeObjet(modele, typeObjet) {
    const config = {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		}
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/types-objet/${typeObjet.id}/supprimer`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiAjouterListeValeurs(modele, listeValeurs) {
    const config = {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(listeValeurs)
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/listes-valeurs/ajouter`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierListeValeurs(modele, listeValeurs) {
    const config = {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(listeValeurs)
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/listes-valeurs/${listeValeurs.id}/modifier`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiSupprimerListesValeurs(modele, listeValeurs) {
	if (listeValeurs.length === 0) {
		return;
	}
	const formulaire = new FormData();
	formulaire.append('idListesValeurs', listeValeurs.map(liste => liste.id));
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/listes-valeurs/supprimer`, {
		method: 'POST',
		headers: {
			'Accept': 'application/json'
		},
		body: formulaire
	});
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiAjouterParametre(modele, parametre) {
    const config = {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(parametre)
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/parametres/ajouter`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierInfosParametre(modele, parametre) {
    const config = {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(parametre)
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/parametres/${parametre.id}/modifier-infos`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiSupprimerParametres(modele, parametres) {
	if (parametres.length === 0) {
		return;
	}
	const formulaire = new FormData();
	formulaire.append('idParametres', parametres.map(param => param.id));
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/parametres/supprimer`, {
		method: 'POST',
		headers: {
			'Accept': 'application/json'
		},
		body: formulaire
	});
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiAjouterConstante(modele, constante) {
    const config = {
		method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(constante)
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/constantes/ajouter`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierConstante(modele, constante) {
    const config = {
		method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(constante)
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/constantes/${constante.id}/modifier`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiSupprimerConstantes(modele, constantes) {
	if (constantes.length === 0) {
		return;
	}
	const formulaire = new FormData();
	formulaire.append('idConstantes', constantes.map(constante => constante.id));
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/constantes/supprimer`, {
		method: 'POST',
		headers: {
			'Accept': 'application/json'
		},
		body: formulaire
	});
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}


export async function apiAjouterDimension(modele, dimension) {
    const config = {
		method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(dimension)
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/dimensions/ajouter`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierInfosDimension(modele, dimension) {
    const config = {
		method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(dimension)
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/dimensions/${dimension.id}/modifier-infos`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiAjouterChamp(modele, champ) {
    const config = {
		method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(champ)
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/types-objet/${champ.idTypeObjet}/champs/ajouter`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierInfosChamp(modele, champ) {
    const config = {
		method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(champ)
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/types-objet/${champ.idTypeObjet}/champs/${champ.id}/modifier-infos`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierFormuleChamp(modele, champ, texte) {
    const config = {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		body: texte
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/types-objet/${champ.idTypeObjet}/champs/${champ.id}/modifier-formule`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiSurchargerChamps(modele, typeObjet, champs) {
	if (champs.length === 0) {
		return;
	}
	const formulaire = new FormData();
	formulaire.append('idChamps', champs.map(chp => chp.id));
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/types-objet/${typeObjet.id}/champs/surcharger`, {
		method: 'POST',
		headers: {
			'Accept': 'application/json'
		},
		body: formulaire
	});
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiSupprimerChamps(modele, champs) {
	if (champs.length === 0) {
		return;
	}
	const idTypeObjet = champs[0].idTypeObjet;
	const formulaire = new FormData();
	formulaire.append('idChamps', champs.map(chp => chp.id));
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/types-objet/${idTypeObjet}/champs/supprimer`, {
		method: 'POST',
		headers: {
			'Accept': 'application/json'
		},
		body: formulaire
	});
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiAjouterImport(modele, infosImport, fichier) {
	const formulaire = new FormData();
	formulaire.append('infosImport', new Blob(
		[JSON.stringify(infosImport)], 
		{ type: 'application/json'}));
	formulaire.append('fichier', fichier);
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/imports/ajouter`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json'
        },
        body: formulaire
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiGetColonnesImport(modele, idImport) {
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/imports/${idImport}/get-colonnes`);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierInfosImport(modele, idImport, infosImport) {
    const config = {
		method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(infosImport)
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/imports/${idImport}/modifier-infos`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierTypeDonneeColonneImport(modele, importDonnees, colonne) {
    const config = {
		method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(colonne)
	};
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/imports/${importDonnees.id}/modifier-type-colonne`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiSupprimerColonnesImport(modele, importDonnees, colonnes) {
	const formulaire = new FormData();
	colonnes.forEach(colonne => formulaire.append('colonnes', colonne.nom));
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/imports/${importDonnees.id}/supprimer-colonnes`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json'
        },
        body: formulaire
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiRemplacerFichierExempleImport(modele, importDonnees, fichier) {
	const formulaire = new FormData();
	formulaire.append('fichier', fichier);
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/imports/${importDonnees.id}/modifier-fichier-exemple`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
        },
        body: formulaire
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierFormuleImport(modele, importDonnees, texte) {
    const config = {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		body: texte
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/imports/${importDonnees.id}/modifier-formule`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierFormuleImportAjoutVariableObjet(modele, importDonnees, infosAjoutVariableObjet) {
    const config = {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(infosAjoutVariableObjet)
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/imports/${importDonnees.id}/modifier-formule-ajout-variable-objet`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierFormuleImportAjoutVariableDimension(modele, importDonnees, infosAjoutVariableDimension) {
    const config = {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(infosAjoutVariableDimension)
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/imports/${importDonnees.id}/modifier-formule-ajout-variable-dimension`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierFormuleImportAlimentationChamps(modele, importDonnees, infosAlimentationChamps) {
    const config = {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(infosAlimentationChamps)
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/imports/${importDonnees.id}/modifier-formule-alimentation-champs`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiSupprimerImports(modele, imports) {
	if (imports.length === 0) {
		return;
	}
	const formulaire = new FormData();
	formulaire.append('idImports', imports.map(importDonnees => importDonnees.id));
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/imports/supprimer`, {
		method: 'POST',
		headers: {
			'Accept': 'application/json'
		},
		body: formulaire
	});
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiAjouterRoutine(modele, routine) {
    const config = {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(routine)
	};
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/routines/ajouter`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierInfosRoutine(modele, idRoutine, routine) {
    const config = {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(routine)
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/routines/${idRoutine}/modifier-infos`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierArgumentsRoutine(modele, idRoutine, argumentsRoutine) {
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/routines/${idRoutine}/modifier-arguments`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(argumentsRoutine)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierFormuleRoutine(modele, routine, texte) {
    const config = {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		},
		body: texte
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/routines/${routine.id}/modifier-formule`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiSupprimerRoutines(modele, routines) {
	if (routines.length === 0) {
		return;
	}
	const formulaire = new FormData();
	formulaire.append('idRoutines', routines.map(routine => routine.id));
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/schema/routines/supprimer`, {
		method: 'POST',
		headers: {
			'Accept': 'application/json'
		},
		body: formulaire
	});
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierValeurs(modele, modifsValeurs) {
	// Enrichissement de idChamp attendu par le back
	for (const modifValeur of modifsValeurs) {
		const coordValeur = modifValeur.coord;
		if (coordValeur.idDimension) {
			coordValeur.idChamp = coordValeur.idDimension;
		} else if (coordValeur.idPopulation) {
			coordValeur.idChamp = coordValeur.idPopulation;
		}
	}
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/donnees/set-valeurs`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(modifsValeurs)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiAjouterObjet(modele, typeObjet, textesValeursCles) {
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/donnees/ajouter-objet`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify({
			idTypeObjet: typeObjet.id,
			textesValeursCles: textesValeursCles
		})
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiSupprimerObjets(modele, idTypeObjet, idObjets) {
	const formulaire = new FormData();
	formulaire.append('idTypeObjet', idTypeObjet);
	formulaire.append('idObjets', idObjets);
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/donnees/supprimer-objets`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
        },
        body: formulaire
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiImporterFichier(modele, idImport, fichier) {
	const formulaire = new FormData();
	formulaire.append('idImport', idImport);
	formulaire.append('fichier', fichier);
	formulaire.append('derniereModificationFichier', fichier.lastModified);
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/donnees/importer-fichier`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
        },
        body: formulaire
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiDeclencherRoutine(modele, idRoutine, textesValeursArgs) {
	const formulaire = new FormData();
	formulaire.append('idRoutine', idRoutine);
	formulaire.append('textesValeursArgs', textesValeursArgs);
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/donnees/declencher-routine`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
        },
        body: formulaire
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiSourcerJeuDonnees(modele, typeSource, jeuDonneesSource) {
	const formulaire = new FormData();
	formulaire.append('typeSource', typeSource);
	formulaire.append('idJeuDonneesSource', jeuDonneesSource.id);
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/donnees/sourcer-jeu`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
        },
        body: formulaire
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiGetJeuxDonnees(modele, nomCampagne) {
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/donnees/${nomCampagne}/get-jeux-donnees`);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiExporterJeuxDonnees(modele, jeuxDonnees) {
	const formulaire = new FormData();
	formulaire.append('idJeuxDonnees', jeuxDonnees.map(jeuDonnees => jeuDonnees.id));
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/donnees/exporter-jeux`, {
        method: 'POST',
        headers: {
            'Accept': 'application/octet-stream',
        },
        body: formulaire
    });
	if (response.ok) {
    	const contenuFichier = await response.blob();
		const contentDisposition = response.headers.get('content-disposition');
		const nomFichier = contentDisposition.replace(/^attachment; filename=\"(.*)\"$/, '$1');
		const url = window.URL.createObjectURL(contenuFichier);
		const lien = document.createElement('a');
		lien.href = url;
		lien.setAttribute('download', nomFichier);
		return lien;
	} else {
		throw await response.json();
	}
}

export async function apiAnnulerDerniereCommande(modele) {
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/annuler-derniere-commande`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        }
	});
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiRefaireProchaineCommande(modele) {
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/refaire-prochaine-commande`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        }
	});
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiCalculer(modele) {
    const config = {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		}
	}
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/donnees/calculer`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiReinitialiserComparaison(modele) {
    const config = {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
		}
	}
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/donnees/reinitialiser-comparaison`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiSelectionnerValeur(modele, selecteur, indiceValeur) {
	const positionBrique = {
		type: null,
		positionSection: selecteur.positionSection,
		positionDansSection: selecteur.positionDansSection,
		positionDansElement: [indiceValeur]
	};
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/selectionner-valeur`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(positionBrique)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiBasculerAffichageElementsMasques(modele) {
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/basculer-affichage-elements-masques`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify({})
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiAjouterElementRapport(modele, positionSection, positionDansSection, typeElement) {	
	const infosBriqueRapport = {
		positionBrique: {
			type: null,
			positionSection: positionSection,
			positionDansSection: positionDansSection,
			positionDansElement: []
		},
		texte: typeElement
	};
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/ajouter-element-rapport`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(infosBriqueRapport)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierLargeurElementRapport(modele, element, modeLargeur) {
	const infosBriqueRapport = {
		positionBrique: {
			type: null,
			positionSection: element.positionSection,
			positionDansSection: element.positionDansSection,
			positionDansElement: []
		},
		texte: modeLargeur
	};
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/modifier-largeur-element-rapport`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(infosBriqueRapport)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierDecalageElementRapport(modele, element, decalage) {
	const infosBriqueRapport = {
		positionBrique: {
			type: null,
			positionSection: element.positionSection,
			positionDansSection: element.positionDansSection,
			positionDansElement: []
		},
		texte: decalage
	};
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/modifier-decalage-element-rapport`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(infosBriqueRapport)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierAlignementElementRapport(modele, element, modeAlignement) {
	const infosBriqueRapport = {
		positionBrique: {
			type: null,
			positionSection: element.positionSection,
			positionDansSection: element.positionDansSection,
			positionDansElement: []
		},
		texte: modeAlignement
	};
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/modifier-alignement-element-rapport`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(infosBriqueRapport)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiTransposerElementsRapport(modele, element) {
	const positionsBriques = [{
		type: null,
		positionSection: element.positionSection,
		positionDansSection: element.positionDansSection,
		positionDansElement: []
	}];
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/transposer-elements-rapport`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(positionsBriques)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiMettreEnFormeElements(modele, misesEnFormeElements) {
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/mettre-en-forme-elements`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(misesEnFormeElements)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierMasquageBriquesRapport(modele, positionsBriques) {
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/modifier-masquages-briques`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(positionsBriques)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiAjouterElementTableau(modele, tableau, type, indices, texte) {
	const infosBriqueRapport = {
		positionBrique: {
			type: type,
			positionSection: tableau.positionSection,
			positionDansSection: tableau.positionDansSection,
			positionDansElement: indices
		},
		texte: texte
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/ajouter-element-tableau`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(infosBriqueRapport)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiEditerFiltreBlocEntetesTableau(modele, tableau, blocEntetes, typeModification, positionExpression, positionValeur, valeurs) {
	const modifFiltreTableau = {
		positionBrique: {
			type: 'BlocEntetesObjets',
			positionSection: tableau.positionSection,
			positionDansSection: tableau.positionDansSection,
			positionDansElement: positionExpression.length ? positionExpression : [blocEntetes.position[0]]
		},
		typeModification: typeModification,
		positionValeur: positionValeur,
		texteValeurs: JSON.stringify(valeurs)
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/modifier-filtre-tableau`, {
        method: 'POST',
        headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json'
        },
        body: JSON.stringify(modifFiltreTableau)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiBasculerAffichageTotauxBlocEntetesTableau(modele, tableau, type, indices) {
	const positionBrique = {
		type: type,
		positionSection: tableau.positionSection, 
		positionDansSection: tableau.positionDansSection, 
		positionDansElement: indices
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/basculer-affichage-totaux`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(positionBrique)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiBasculerAffichageSousTotauxRegroupementTableau(modele, positionBriqueRapport) {
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/basculer-affichage-sous-totaux`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(positionBriqueRapport)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiAfficherTypeObjetDansBriqueRapport(modele, infoBrique) {
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/afficher-type-objet-dans-brique-rapport`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(infoBrique)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiAfficherChampsDansBriqueRapport(modele, infosAffichageChamps) {
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/afficher-champs-dans-brique-rapport`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(infosAffichageChamps)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiGetDescriptionBriques(modele, positionsBriques) {
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/get-briques-rapport`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(positionsBriques)
    });
	if (response.ok) {
    	return await response.text();
	} else {
		throw await response.json();
	}
}

export async function apiCollerBriquesRapport(modele, infoBrique) {
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/coller-briques-rapport`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(infoBrique)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiDeplacerBriquesRapport(modele, infosDeplacement) {
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/deplacer-briques-rapport`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(infosDeplacement)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiSupprimerBriquesRapport(modele, positionsBriques) {
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/supprimer-briques-rapport`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(positionsBriques)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierTextesBriquesRapport(modele, infosBriquesRapport) {
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/modifier-textes-briques-rapport`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(infosBriquesRapport)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierExpression(modele, infoBrique) {
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/modifier-expression`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
			'Content-type': 'application/json'
        },
        body: JSON.stringify(infoBrique)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierNomVariableCalculable(modele, infoBrique) {
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/modifier-nom-variable-calculable`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
			'Content-type': 'application/json'
        },
        body: JSON.stringify(infoBrique)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierTypeFormatExpressions(modele, infosBriques) {
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/modifier-type-format-expressions`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
			'Content-type': 'application/json'
        },
        body: JSON.stringify(infosBriques)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierDecalageBlocEntetesTableau(modele, tableau, blocEntetes, decalage) {
	const infosBriqueRapport = {
		positionBrique: {
			type: blocEntetes.type,
			positionSection: tableau.positionSection,
			positionDansSection: tableau.positionDansSection,
			positionDansElement: blocEntetes.position
		},
		texte: decalage
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/modifier-decalage-bloc-entetes-tableau`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(infosBriqueRapport)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiSupprimerBlocEntetesTableau(modele, tableau, type, indices) {
	const positionBrique = {
		type: type,
		positionSection: tableau.positionSection,
		positionDansSection: tableau.positionDansSection,
		positionDansElement: indices
	};
	const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/supprimer-bloc-entetes-tableau`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(positionBrique)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiModifierTypeGraphique(modele, graphique, typeGraphique) {
	const infosBriqueRapport = {
		positionBrique: {
			type: null,
			positionSection: graphique.positionSection,
			positionDansSection: graphique.positionDansSection,
			positionDansElement: []
		},
		texte: typeGraphique
	};
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/modifier-type-graphique`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(infosBriqueRapport)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiAjouterSerieGraphique(modele, graphique, indice) {
	const positionBrique = {
		type: null,
		positionSection: graphique.positionSection,
		positionDansSection: graphique.positionDansSection,
		positionDansElement: [indice]
	};
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/rapport/ajouter-serie-graphique`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(positionBrique)
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiOuvrirJeuDonnees(modele, jeuDonnees) {
	const jeuDonneesDTO = {
		nomCampagne: jeuDonnees.campagne,
		hypotheses: jeuDonnees.hypotheses.map(hyp => hyp.valeur)
	};
    const config = {
		method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(jeuDonneesDTO)
	};
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/donnees/ouvrir-jeu`, config);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiEnregistrer(modele, nomModele, ecraserSiExistant) {
	const formulaire = new FormData();
	formulaire.append('nomModele', nomModele);
	formulaire.append('ecraserSiExistant', ecraserSiExistant);
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/enregistrer`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json'
        },
        body: formulaire
	});
	if (response.ok) {
    	return await response.json();
	} else if (response.status === 403) {
		return null;
	} else {
		throw await response.json();
	}
}

export async function apiOuvrirModele(nomModele) {
	const formulaire = new FormData();
	formulaire.append('nomModele', nomModele);
    const response = await apiFetch(`/api/modeles/ouvrir`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json'
        },
        body: formulaire
	});
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiExporterModele(nomModele) {
	const formulaire = new FormData();
	formulaire.append('nomModele', nomModele);
    const response = await apiFetch(`/api/modeles/exporter`, {
        method: 'POST',
        headers: {
            'Accept': 'application/octet-stream',
        },
        body: formulaire
    });
	if (response.ok) {
    	const contenuFichier = await response.blob();
		const contentDisposition = response.headers.get('content-disposition');
		const nomFichier = contentDisposition.replace(/^attachment; filename=\"(.*)\"$/, '$1');
		const url = window.URL.createObjectURL(contenuFichier);
		const lien = document.createElement('a');
		lien.href = url;
		lien.setAttribute('download', nomFichier);
		return lien;
	} else {
		throw await response.json();
	}
}

export async function apiImporterModele(fichier, nomModele) {
	const formulaire = new FormData();
	formulaire.append('fichier', fichier);
	formulaire.append('nomModele', nomModele);
    const response = await apiFetch(`/api/modeles/importer`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
        },
        body: formulaire
    });
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiCreerNouveauModele(infosModele) {
	const formulaire = new FormData();
	formulaire.append('nomModele', infosModele.nomModele);
	formulaire.append('nomCampagne', infosModele.nomCampagne);
    const response = await apiFetch(`/api/modeles/nouveau-modele`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json'
        },
		body: formulaire
	});
	if (response.ok) {
		return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiGetModelesPrives() {
	const response = await apiFetch('/api/modeles');
	if (response.ok) {
		return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiGetModele(idModele) {
    const response = await apiFetch(`/api/modeles/${idModele}`);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiOublierModificationsModele(idModele) {
    const response = await apiFetch(`/api/modeles/${idModele}/oublier-modifications`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json'
        }
	});
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiSupprimerModele(nomModele) {
	const formulaire = new FormData();
	formulaire.append('nomModele', nomModele);
    const response = await apiFetch(`/api/modeles/supprimer`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json'
        },
        body: formulaire
	});
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiGetDernieresCommandes(modele) {
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/get-dernieres-commandes`);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}

export async function apiOublierDernieresCommandes(modele, nbCommandes) {
    const response = await apiFetch(`/api/modeles/${modele.id}/${modele.infosModele.derniereModification}/oublier-dernieres-commandes/${nbCommandes}`);
	if (response.ok) {
    	return await response.json();
	} else {
		throw await response.json();
	}
}
